import React from 'react';
import clsx from 'clsx';
import {ReactComponent as DoneIcon} from '../assets/done.svg';
import {ReactComponent as TrashIcon} from '../assets/trash_icon.svg';

interface BoxHeaderProps {
    removeEventFromCoupon: () => void;
    changeEventActiveStatus: () => void,
    isActive: boolean,
    competitionName?: string,
    marketName?: string
}

function CouponBoxHeader(props: BoxHeaderProps) {
    const {isActive, changeEventActiveStatus, removeEventFromCoupon} = props;

    return (
        <div className="flex border-b border-[#171A1E]">
            <div
                className={"flex justify-center items-center cursor-pointer w-[42px] desktop:w-[62px] border-r border-[#171A1E]"}
                onClick={changeEventActiveStatus}
            >
                <div
                     className={clsx(
                         "flex justify-center items-center transition-all duration-[400ms] border border-[#16181B] rounded-full w-7 h-7 desktop:w-[42px] desktop:h-[42px]",
                         isActive ? "bg-[#16181B]" : "bg-transparent"
                     )}
                >
                    <DoneIcon display={isActive ? "bg-[#16181B]" : 'none'}/>
                </div>
            </div>

            <div className="mr-auto py-[12px] px-[10px] text-[12px] desktop:text-[14px] font-['Roboto'] leading-[100%] text-[#ABABAB]">
                <div className="mb-[2px]">{props.competitionName}{' '}</div>
                <div>{props.marketName} </div>
            </div>

            <button className={clsx("cursor-pointer w-[42px] desktop:w-[62px]", "border-l border-[#171A1E]")} onClick={removeEventFromCoupon}>
                <div className="flex justify-center items-center w-[19px] h-[19px] desktop:w-7 desktop:h-7 ml-3">
                    <TrashIcon/>
                </div>
            </button>
        </div>
    );
}

export default CouponBoxHeader;
